import React, { useContext } from 'react';

import { LocationContext } from 'app/containers/LocationProvider';
import { analyticService } from 'global/services';
import Icon from './Frame-1.svg';
import { getCityMetaByLocationKey } from 'app/const/location';

import FilterItem from '../FilterItem';
import CityList from './CityList';
import { locales } from './period.locales';


class CityFilter extends React.PureComponent {
    state = {
        isExpanded: false,
    };

    handleToggle = (isExpanded) => {
        if (isExpanded) {
            analyticService.push({ eventName: 'Filter_Open_City', eventAction: 'Open', eventLabel: 'City' });
        }
        this.setState({
            isExpanded,
        });
    };

    onSelect = () => { };

    render() {
        const {
            title, locale, mutateAddreessHandler, locationKey, isLocationDataLoading,
        } = this.props;
        const { isExpanded } = this.state;

        // Locale content data
        const { regionTitle } = locales[locale];

        return (
            <FilterItem
                title={regionTitle}
                subtitle={() => title}
                Icon={Icon}
                isExpanded={isExpanded}
                onToggle={this.handleToggle}
            >
                <CityList
                    isExpanded={isExpanded}
                    onSelect={this.onSelect}
                    locale={locale}
                    locationKey={locationKey}
                    isLocationDataLoading={isLocationDataLoading}
                    mutateAddreessHandler={mutateAddreessHandler}
                />
            </FilterItem>
        );
    }
}

const CityFilterDataAccessContainer = (props) => {
    const {
        locationKey, mutateAddreessHandler, isLocationDataLoading,
    } = useContext(LocationContext);

    const { longTitle } = getCityMetaByLocationKey(locationKey);

    return (
        <CityFilter
            {...props}
            title={longTitle}
            locationKey={locationKey}
            isLocationDataLoading={isLocationDataLoading}
            mutateAddreessHandler={mutateAddreessHandler}
        />
    );
};

export default React.memo(CityFilterDataAccessContainer);
